import db from "@/plugins/dexie";
import apivarejoweb from '@/services/api-varejoweb';
import moment from "moment-timezone";
import store from "@/store";
import geraData, { converterDataApiParaLocal } from '@/utils/geradata';

import $_enviaImagem from "./enviaImagem"; 
import $_enviaVeiculo from "./enviaVeiculo"; 

const tabela = 'prestacaoservicoitem';
const idnuvem = 'priidnuvem';

export default async function $_enviaPrestacaoServicoItem(idParentLocal = null) {

  const tokenString = sessionStorage.getItem('auth:token');

  if (!tokenString || tokenString === 'undefined' || tokenString === 'null') {
    console.warn("⚠️ [enviaCadastroItem] Token não encontrado, abortando.");
    return;
  }
  const token = JSON.parse(tokenString);
  
  let itens = await db[tabela].toArray();

  if (idParentLocal) {
    const parentOS = await db.prestacaoservico.get(idParentLocal);
    if (parentOS) {
      itens = itens.filter(i => 
        i.idprestacaoservico === idParentLocal ||
        (parentOS.prslinkpedidoitem && i.prilinkpedidoitem === parentOS.prslinkpedidoitem) ||
        (parentOS.prsidnuvem && i.priidprestacaoserviconuvem && String(i.priidprestacaoserviconuvem) === String(parentOS.prsidnuvem))
      );
      if (parentOS.prsidnuvem) {
        itens.forEach(i => {
          if (!i.priidprestacaoserviconuvem || i.priidprestacaoserviconuvem === 'null') {
            i.priidprestacaoserviconuvem = parentOS.prsidnuvem;
          }
        });
      }
    } else {
      itens = [];
    }
  } else {
    for (const i of itens) {
      if (!i.priidprestacaoserviconuvem || i.priidprestacaoserviconuvem === 'null') {
        if (i.idprestacaoservico) {
          const parentOS = await db.prestacaoservico.get(i.idprestacaoservico);
          if (parentOS && parentOS.prsidnuvem) {
            i.priidprestacaoserviconuvem = parentOS.prsidnuvem;
          }
        }
      }
    }
  }

  itens = itens.filter(i => {

    if (!i.priidprestacaoserviconuvem || i.priidprestacaoserviconuvem === 'null' || i.priexclusao) {
      return false;
    }
    
    const semTransmissao = !i.pridatatransmissao || i.pridatatransmissao === 'null';
    const semIdNuvem = !i[idnuvem] || i[idnuvem] === 'null';
    
    if (semTransmissao || semIdNuvem) {
      return true;
    }

    const dtAlteracao = moment(i.pridataalteracao);
    const dtTransmissao = moment(i.pridatatransmissao);
    
    const foiEditado = dtAlteracao.isValid() && dtTransmissao.isValid() && dtAlteracao.isAfter(dtTransmissao);

    return foiEditado;
  });


  const formataData = (data, formato) => {
    if (!data || data === 'null' || data === '') return null;
    const m = moment(data);
    return m.isValid() ? m.format(formato) : null;
  };

  const promises = itens.map(async (item) => {

    const payload = {
      IDORDEMSERVICO: item.priidprestacaoserviconuvem,
      IDPRODUTO: item.priidproduto,
      DESCRICAOITEM: item.pridescricao,
      item: item.priordem,
      QUANTIDADE: item.priquantidade,
      PRECOUNITARIO: item.privalor,
      DataItem: formataData(item.pridatainclusao, 'YYYY-MM-DD HH:mm:ss'),
      IOSIdUsuarioCadastro: item.priidusuario,
      IDTECNICO: item.pritecnico,
      IDTECNICO2: item.pritecnico2,
      IDTECNICO3: item.pritecnico3,
      VALORTECNICO: item.privalortecnico,
      VALORTECNICO2: item.privalortecnico2,
      VALORTECNICO3: item.privalortecnico3,
      IdTecnicoRetirouPeca: item.pritecnicoretiroupeca,
      DescricaoComplementar: item.priobservacao,
      IOSDataAlteracao: formataData(item.pridataalteracao, 'YYYY-MM-DD HH:mm:ss'),
    };

    let res = null;
    try {
      if (item[idnuvem] && item[idnuvem] !== 'null') {
        res = await apivarejoweb.put(`/prestacaoservicoitem/${item[idnuvem]}`, payload, {
          headers: { Authorization: `Bearer ${token.token}` }
        });
      } else {
        
        res = await apivarejoweb.post('/prestacaoservicoitem', payload, {
          headers: { Authorization: `Bearer ${token.token}` }
        });
      }
    } catch (err) {
      console.error(`❌ [enviaCadastroItem] Erro ao enviar item ${item.id}:`, err.response?.data || err);
    }

    if (res && res.data) {
      const apiDataRaw = res.data.IOSDataAlteracao || res.data.ORSDataAlteracao;
      const alteracao = apiDataRaw ? converterDataApiParaLocal(apiDataRaw) : (item.pridataalteracao || geraData());
      const dataTransmissao = geraData();
      
      await db[tabela].update(item.id, {
        priidnuvem: res.data.id ?? item[idnuvem],
        pridataalteracao: alteracao,
        pridatatransmissao: dataTransmissao,
      });

      store.dispatch('cache/atualizaData', { data: alteracao, tabela: `${tabela}` });
    }
    
    return res;
  });

  await Promise.all(promises);
  
  await store.dispatch('cache/reloadCache', 'prestacaoservicoitem');
  
  if (idParentLocal && typeof $_enviaVeiculo === 'function') {
    await $_enviaVeiculo(idParentLocal);
  }

  if (typeof $_enviaImagem === 'function') {
    await $_enviaImagem(idParentLocal);
  }
}